import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ChannelManagerPage from './pages/ChannelManagerPage';
import ConfigPanelPage from './pages/ConfigPanelPage';
import APKManagerPage from './pages/APKManagerPage';
import AnalyticsPage from './pages/AnalyticsPage';
import DeviceManagerPage from './pages/DeviceManagerPage';
import PackageManagementPage from './pages/PackageManagementPage';
import SubscriptionRequestsPage from './pages/SubscriptionRequestsPage';
import SubscriptionHistoryPage from './pages/SubscriptionHistoryPage';
import SubscriptionAnalyticsPage from './pages/SubscriptionAnalyticsPage';
import PaymentMethodsPage from './pages/PaymentMethodsPage';
import WebPayPage from './pages/WebPayPage';

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const initializeAuth = useAuthStore((state) => state.initializeAuth);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Initialize auth from localStorage
    initializeAuth();
    setIsLoading(false);
  }, [initializeAuth]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-gray-800">
        <div className="animate-spin">
          <div className="w-16 h-16 border-4 border-purple-500 border-t-purple-200 rounded-full"></div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <LoginPage />} />

        {/* Protected Routes */}
        <Route
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/channels" element={<ChannelManagerPage />} />
          <Route path="/devices" element={<DeviceManagerPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/payments" element={<PaymentMethodsPage />} />
          <Route path="/apk" element={<APKManagerPage />} />
          <Route path="/config" element={<ConfigPanelPage />} />
          <Route path="/subscriptions/packages" element={<PackageManagementPage />} />
          <Route path="/subscriptions/requests/:status" element={<SubscriptionRequestsPage />} />
          <Route path="/subscriptions/history" element={<SubscriptionHistoryPage />} />
          <Route path="/subscriptions/analytics" element={<SubscriptionAnalyticsPage />} />
          <Route path="/webpay" element={<WebPayPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;
